import { TMedEventUI } from 'src/types/med-event'
import type { TFunction } from 'i18next'
import { getTranslatedLabel } from 'src/utils/locale.util'
import type { TNavigationLocales } from 'src/types/locales'

const getDateLabel = ({
  t,
  medEventUI,
  locale,
}: {
  t: TFunction
  medEventUI?: TMedEventUI
  locale?: string
}) => {
  const defaultLabel = t('components.generic-followups-form.date-label')
  if (!locale || !medEventUI) {
    return defaultLabel
  }
  const dateLabel = getTranslatedLabel(
    locale as TNavigationLocales,
    medEventUI?.properties?.find((property) => property.fieldName === 'date')?.label,
  )
  return dateLabel ? dateLabel.replace(' :', '') : defaultLabel
}

const getConvocationLabel = ({
  t,
  medEventUI,
  locale,
}: {
  t: TFunction
  medEventUI?: TMedEventUI
  locale?: string
}) => {
  const defaultLabel = t('components.generic-followups-form.convocation-label')
  if (!locale || !medEventUI) {
    return defaultLabel
  }
  const convocationLabel = getTranslatedLabel(
    locale as TNavigationLocales,
    medEventUI?.properties?.find((property) => property.fieldName === 'convocationDate')?.label,
  )
  return convocationLabel ? convocationLabel.replace(' :', '') : defaultLabel
}

export { getDateLabel, getConvocationLabel }
